import React from "react";
import {
  Button,
  ButtonGroup,
  Form,
  FormControl,
  InputGroup,
  ToggleButton,
} from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";
import { isMobile } from "react-device-detect";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import { getFullName } from "../../../Modules/utils/fullname";
import RenderAmount from "../../../Components/etc/RenderAmount";
import AppTable from "../../Components/AppTable";
import AccountDetails from "../AccountsScreen/AccountDetails";

const SCREEN_NAME = "REPORTS_SCREEN";

class AgentCommissionSheetInner extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      commissions: [],
      total: null,
      accountType: "",
    };

    let columns = [
      {
        value: "sl",
        label: "SL No",
        render: ({ index }) => index,
      },
      {
        value: "t",
        label: "Date",
        render: ({ item }) => item.t && new Date(item.t).toLocaleDateString(),
      },
      {
        value: "name",
        label: "Name",
        render: ({ item }) => getFullName(item.agent),
      },
      {
        value: "shortId",
        label: "Account ID",
        render: ({ item }) => (
          <div
            className="hoveredlink"
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "accountDetails",
                modalData: { account: item.account },
              });
            }}
          >
            {item?.account?.shortId}
          </div>
        ),
      },
      {
        value: "transactionType",
        label: "Transaction Type",
        render: ({ item }) => _.startCase(item.transactionType),
      },
      {
        value: "transaction.amount",
        label: "Transaction Amount",
        render: ({ item }) => (
          <RenderAmount value={item.transaction?.amount?.toFixed?.(2)} />
        ),
      },

      {
        value: "interestRate",
        label: "Interest Rate",
        render: ({ item }) =>
          item.transaction?.collectorCommission ? (
            <div className="numeric">
              {item.transaction?.collectorCommission}%
            </div>
          ) : (
            ""
          ),
      },

      {
        value: "amount",
        label: "Commission Amount",
        render: ({ item }) => (
          <RenderAmount value={item.amount?.toFixed?.(2)} />
        ),
      },

      // {
      //   value: "note",
      //   label: "Note",
      //   render: ({ item }) =>
      //     item.note?.length > 15 ? item.note.substr(0, 15) + "..." : item.note,
      //   hideInMobile: true,
      // },
    ].filter((x) => (isMobile ? !x.hideInMobile : true));

    if (this.props.filteredColumns) {
      let newColumns = [];

      for (let i = 0; i < this.props.filteredColumns.length; i++) {
        const colValue = this.props.filteredColumns[i];

        const col = columns.find((x) => x.value === colValue);
        if (col) {
          newColumns.push(col);
        }
      }

      this.columns = newColumns;
    } else {
      this.columns = columns;
    }

    this.months = "January, February, March, April, May, June, July, August, September, October, November, December"
      .split(",")
      .map((x) => x.trim());
  }

  componentDidMount() {
    this.onMount();
    this.onSubmit();
    this.loadAgents();
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });

      let whereQuery = {
        t: { $gte: new Date(range0), $lt: new Date(range1) },
      };
      if (this.state.selectedAgent) {
        whereQuery.agent = this.state.selectedAgent;
      }
      const res = await api.get("v1/commission", {
        queryStr: JSON.stringify({
          where: whereQuery,
          populate: "agent transaction account",
        }),
      });

      let commissions = res.commissions;
      if (this.state.accountType)
        commissions = commissions.filter(
          (x) => x?.account?.accountType === this.state.accountType
        );

      const total = {
        _id: "total",
        transaction: {
          amount: commissions
            ?.map((x) => x.transaction?.amount || 0)
            .reduce((a, b) => a + b, 0),
        },
        amount: commissions
          ?.map((x) => x.amount || 0)
          .reduce((a, b) => a + b, 0),
      };

      this.setAsyncState({
        commissions: commissions,
        total: total,
        loading: false,
      });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  async loadAgents() {
    try {
      const { agents } = await api.get("v1/agent", {
        queryStr: JSON.stringify({}),
      });
      this.setAsyncState({ agents });
    } catch (e) {
      console.error("Error loading agents: ", e.message);
    }
  }

  render() {
    const {
      state: {
        month,
        year,
        loading,
        error,
        visibleModal,
        modalData,
        commissions,
        total,
        agents,
        selectedAgent,
        accountType,
      },
      props: { title },
    } = this;

    const items = commissions?.length ? [total || {}, ...commissions] : [];

    const content = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">{title || "Agent's Commission Sheet"}</div>
          </div>
          <div className="right">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                this.onSubmit();
              }}
            >
              <InputGroup className="mb-3">
                <FormControl
                  value={month || ""}
                  onChange={(e) => this.setState({ month: e.target.value })}
                  as="select"
                  required
                >
                  <option value="">Select Month</option>
                  {this.months.map((x, i) => (
                    <option key={i} value={i}>
                      {x}
                    </option>
                  ))}
                </FormControl>
                <FormControl
                  type="number"
                  value={year || ""}
                  onChange={(e) => this.setState({ year: e.target.value })}
                  placeholder="Year"
                  required
                />

                <Button disabled={loading} type="submit">
                  Load
                </Button>
              </InputGroup>
            </Form>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <FormControl
            as="select"
            style={{
              // padding: "0.5rem 0px",
              margin: "0 0.25rem",
              width: "10rem",
            }}
            value={selectedAgent || ""}
            onChange={(e) =>
              this.setAsyncState({ selectedAgent: e.target.value }).then(() =>
                this.onSubmit()
              )
            }
          >
            <option value="">All Agents</option>
            {agents?.map((x) => (
              <option key={x._id} value={x._id}>
                {getFullName(x)}
              </option>
            ))}
          </FormControl>

          <ButtonGroup className="m-1">
            {["", "loan", "deposit"].map((radio) => (
              <ToggleButton
                key={`commission-accounttype-${radio}`}
                id={`commission-accounttype-${radio}`}
                type="radio"
                variant="outline-success"
                name="commission-accounttype"
                value={radio}
                checked={accountType === radio}
                onChange={(e) =>
                  this.setAsyncState({
                    accountType: e.currentTarget.value,
                  }).then(() => this.onSubmit())
                }
                disabled={loading}
              >
                {_.startCase(radio || "all")}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </div>

        <div>
          <AppTable
            {...{
              items,
              loading,
              error,
              table: {
                columns: this.columns,
                getStyle: ({ item }) =>
                  item._id === "total"
                    ? { color: "blue", fontWeight: "bold" }
                    : null,
                // onRowClick: ({ item, index }) =>
                //   this.setAsyncState({
                //     visibleModal: "transactionDetails",
                //     modalData: { transaction: item, index },
                //   }),
              },
            }}
          />
        </div>

        <AccountDetails
          {...{
            key: `accountDetails-${
              visibleModal === "accountDetails"
                ? modalData?.account?.shortId || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "accountDetails",
            shortId: modalData?.account?.shortId,
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />
      </div>
    );

    return content;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const AgentCommissionSheet = connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentCommissionSheetInner);

export default AgentCommissionSheet;
